import React, { useState, ChangeEvent, FormEvent } from 'react';
import {
  adStateCode,
  errorCode,
  playerStateCode,
  sessionStateCode,
} from './codes';

import ResultList from '../../components/ResultList';

import './styles.css';

const ErrorCodeMapping = () => {
  const [formData, setFormData] = useState({
    code: '',
  });
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [codes, setCodes] = useState([] as string[]);
  const [values, setValues] = useState([] as string[]);

  function handleInputChange(event: ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target;

    setShowErrorMessage(false);

    setFormData({
      ...formData,
      [name]: value,
    });
  }

  function translateCodes(codes: string[], mapToShow: Map<string, string>) {
    for (let index = 0; index < codes.length; index++) {
      const element = codes[index];
      switch (index) {
        case 0:
          // Get the Error code
          const errorCodeValue = errorCode.get(element);
          mapToShow.set(element, errorCodeValue ?? 'Unknwon Code');
          break;
        case 1:
          // Get the session code
          mapToShow.set(`${element}|session`, sessionStateCode.get(element));
          break;
        case 2:
          // Get the Player state code
          mapToShow.set(`${element}|PEI_State`, playerStateCode.get(element));
          break;
        case 3:
          // Get the Ads state code
          if (hasErrorMessage(element)) {
            const split = element.split('-');
            const adState = split[0].trim();
            const errorMessage = split[1].trim();
            mapToShow.set(`${adState}|adState`, adStateCode.get(adState));
            mapToShow.set('Error Message', errorMessage);
          } else {
            mapToShow.set(`${element}|adState`, adStateCode.get(element));
          }

          break;
        default:
          mapToShow.set('UNKNOWN', element);
      }
    }
  }

  function hasErrorMessage(text: string) {
    return text.includes('-');
  }

  function clearMapping() {
    setCodes([]);
    setValues([]);
  }

  function handleSubmit(event: FormEvent) {
    event.preventDefault();

    clearMapping();

    let insertedCode = formData.code;
    if (!insertedCode) {
      setShowErrorMessage(true);
      return;
    }

    const mapToShow = new Map();
    // Example: CVF_EDI|JIS:4:5:0
    // Mount code: val code = "${error.code}:${sessionStateCode?.ordinal}:$playerStateCode:${adStateCode.ordinal}"

    if (insertedCode.startsWith('CVF')) {
      insertedCode = insertedCode.substring(
        insertedCode.indexOf('_') + 1,
        insertedCode.length
      );
    }

    if (insertedCode.includes('|')) {
      // Get the first code
      const element = insertedCode.split('|')[0];

      const errorCodeValue = errorCode.get(element);
      mapToShow.set(element, errorCodeValue ?? 'Unknwon Code');

      const secondSlice = insertedCode.split('|')[1];
      if (secondSlice.includes(':') && secondSlice.split(':').length > 2) {
        const codes = secondSlice.split(':');
        translateCodes(codes, mapToShow);
      } else {
        if (hasErrorMessage(secondSlice)) {
          const split = secondSlice.split('-');
          const errorCd = split[0].trim();
          const errorMessage = split[1].trim();
          mapToShow.set(errorCd, errorCode.get(errorCd));
          mapToShow.set('Error Message', errorMessage);
        } else {
          mapToShow.set(secondSlice, errorCode.get(secondSlice));
        }
      }
    } else {
      const codes = insertedCode.split(':');
      translateCodes(codes, mapToShow);
    }

    mapToShow.forEach((value, key) => {
      setCodes((codes) => [...codes, key.split('|')[0]]);
      setValues((values) => [...values, value]);
    });
  }

  return (
    <div id="page-error-code-mapping">
      <form onSubmit={handleSubmit}>
        <h1>Core Video Team</h1>

        <fieldset>
          <div className="field">
            <label htmlFor="name">Error Code</label>
            <div className="input-content-grid">
              <input
                type="text"
                id="code"
                name="code"
                onChange={handleInputChange}
              />
              <button type="submit">GO</button>
            </div>
            
            {showErrorMessage && <span id="error-name">Required field</span>}

            <ResultList values={values} codes={codes} />
          </div>
        </fieldset>
      </form>
    </div>
  );
};

export default ErrorCodeMapping;
